<div class="dvs-chart">
	<highcharts-chart *ngIf="options" [class.light]="light" [style.height]="height" [Highcharts]="Highcharts" [options]="options" (chartInstance)="onLoad($event)"></highcharts-chart>
	<div *ngIf="!options" [class.light]="light" [style.height]="height" class="chartloading">
		<div *ngIf="!error" class="indicator" [ngClass]="{ short }">
			<div class="logo-spin" [class.light]="light"></div>
			<span *ngIf="!short">Loading...</span>
		</div>
		<div *ngIf="error" class="indicator" [ngClass]="{ short }">
			<div class="logo-spin stopped" [class.light]="light"></div>
			{{error}}
		</div>
	</div>
</div>